import { createContext, useContext, useEffect, useState } from 'react';

// 1️⃣ Create context object
const CartContext = createContext();

// 2️⃣ Export provider component
export const CartProvider = ({ children }) => {
  // Open state for cart drawer
  const [isCartOpen, setIsCartOpen] = useState(false);
	
	const initialSession = (() => {
		try {
			const stored = localStorage.getItem('bookingSession');
			return stored ? JSON.parse(stored) : {};
		} catch {
			return {};
		}
	})();
	
	const [bookingDate, setBookingDate] = useState(initialSession.bookingDate || '');
	const [startTime, setStartTime] = useState(initialSession.startTime || '');
	const [endTime, setEndTime] = useState(initialSession.endTime || '');
	const [description, setDescription] = useState(initialSession.description || '');	

  

  // ✅ Save booking session on change
  useEffect(() => {
		const bookingSession = {
			bookingDate,
			startTime,
			endTime,
			description,
		};
		localStorage.setItem('bookingSession', JSON.stringify(bookingSession));
	}, [bookingDate, startTime, endTime, description]);
	

  // Items in cart (initially from localStorage)
  const [cartItems, setCartItems] = useState(() => {
    try {
      const stored = localStorage.getItem('cartItems');
      return stored ? JSON.parse(stored) : [];
    } catch (err) {
      console.error('Error reading cart from localStorage:', err);
      return [];
    }
  });

  // Save cart to localStorage on change
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

  return (
    <CartContext.Provider
      value={{
        isCartOpen,
        setIsCartOpen,
        cartItems,
        setCartItems,
        bookingDate,
        setBookingDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        description,
        setDescription,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

// 4️⃣ Custom hook for using cart state
export const useCart = () => useContext(CartContext);
